import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ImportDetailPage, ROW_FILTERS } from "@/features/lead-imports/import-detail-page";

export const Route = createFileRoute("/_authenticated/$store/imports/$importId")({
  validateSearch: z.object({
    rows: z
      .enum(ROW_FILTERS.filter((f) => f !== "all") as ["CREATED", "DUPLICATE", "FAILED"])
      .optional()
      .catch(undefined),
  }),
  head: () => ({ meta: [{ title: "Lead import · Rogue AI" }] }),
  component: ImportDetailPage,
});
